import { c as _c } from "react/compiler-runtime";
import CommonTablePagination from "@/components/utils/table/paginator/CommonTablePagination";
import type { ApiXTdhToken } from "@/generated/models/ApiXTdhToken";
import { formatStatFloor } from "@/helpers/Helpers";
import { useTokenMetadataQuery } from "@/hooks/useAlchemyNftQueries";
import { useMemo, useState } from "react";
export default function UserPageCollectedNetworkCards({
  cards,
  page,
  setPage,
  next
}: {
  readonly cards: ApiXTdhToken[];
  readonly page: number;
  readonly setPage: (page: number) => void;
  readonly next: boolean;
}) {
  if (!cards.length) {
    return <div className="tw-w-full tw-text-center tw-py-10 tw-text-iron-400">
        No tokens found
      </div>;
  }
  const tokens = useMemo(() => cards.map(card => ({
    contract: card.contract,
    tokenId: card.token.toString()
  })), [cards]);
  const {
    data: metadata
  } = useTokenMetadataQuery({
    tokens,
    enabled: cards.length > 0
  });
  return <div className="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 tw-gap-4 lg:tw-gap-6 tw-pb-2">
      {cards.map(card_0 => <NetworkCard key={`${card_0.contract}-${card_0.token}`} card={card_0} metadata={metadata} />)}
      <div className="tw-col-span-full tw-mt-4">
        <CommonTablePagination currentPage={page} setCurrentPage={setPage} totalPages={next ? page + 1 : page} haveNextPage={next} small={false} loading={false} />
      </div>
    </div>;
}
function NetworkCard(t0) {
  const $ = _c(44);
  const {
    card,
    metadata
  } = t0;
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  let t1;
  if ($[0] !== card.contract || $[1] !== card.token || $[2] !== metadata) {
    t1 = metadata?.find(m => m.tokenIdRaw === card.token.toString() && m.contract?.toLowerCase() === card.contract.toLowerCase());
    $[0] = card.contract;
    $[1] = card.token;
    $[2] = metadata;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const tokenMetadata = t1;
  const imageUrl = tokenMetadata?.imageUrl;
  let t2;
  if ($[4] !== isImageLoaded) {
    t2 = !isImageLoaded && <div className="tw-absolute tw-inset-0 tw-bg-iron-800 tw-animate-pulse tw-rounded-lg" />;
    $[4] = isImageLoaded;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== imageUrl || $[7] !== isImageLoaded || $[8] !== tokenMetadata?.collectionName) {
    t3 = imageUrl && <img src={imageUrl} alt={tokenMetadata?.collectionName ?? "Network Token"} onLoad={() => setIsImageLoaded(true)} className={`tw-bg-transparent tw-max-w-full tw-max-h-full tw-h-auto tw-w-auto tw-mx-auto tw-object-contain ${!isImageLoaded ? "tw-opacity-0" : "tw-opacity-100"} tw-transition-opacity tw-duration-300`} />;
    $[6] = imageUrl;
    $[7] = isImageLoaded;
    $[8] = tokenMetadata?.collectionName;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <div className="tw-w-full tw-max-w-full"><div className="tw-h-[200px] min-[800px]:tw-h-[250px] min-[1200px]:tw-h-[18.75rem] tw-text-center tw-flex tw-items-center tw-justify-center tw-relative tw-w-full">{t2}{t3}</div></div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = tokenMetadata?.collectionName ?? "Network";
  let t6;
  if ($[13] !== t5) {
    t6 = <span className="tw-text-sm min-[1200px]:tw-text-md tw-font-medium tw-text-iron-400">{t5}</span>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== card.token) {
    t7 = <span className="tw-text-sm min-[1200px]:tw-text-md tw-font-medium tw-text-iron-500">#{card.token}</span>;
    $[15] = card.token;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <div className="tw-pt-3 tw-px-2 tw-flex tw-justify-between tw-items-center tw-w-full">{t6}{t7}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t4 || $[21] !== t8) {
    t9 = <div className="tw-flex tw-flex-wrap">{t4}{t8}</div>;
    $[20] = t4;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const t10 = tokenMetadata?.name ?? `Token #${card.token}`;
  let t11;
  if ($[23] !== t10) {
    t11 = <div className="tw-flex tw-justify-between tw-gap-x-2"><span className="tw-text-sm min-[1200px]:tw-text-md tw-font-medium tw-text-iron-50 tw-truncate tw-block tw-w-full">{t10}</span></div>;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="tw-text-iron-400">xTDH</span>;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== card.xtdh) {
    t13 = formatStatFloor(card.xtdh, 1);
    $[26] = card.xtdh;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13) {
    t14 = <span className="tw-text-sm min-[1200px]:tw-text-md tw-font-medium">{t12}<span className="tw-ml-1 tw-text-iron-50">{t13}</span></span>;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span className="tw-text-iron-400">xTDH/day</span>;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== card.xtdh_rate) {
    t16 = formatStatFloor(card.xtdh_rate, 1);
    $[31] = card.xtdh_rate;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t16) {
    t17 = <span className="tw-text-sm min-[1200px]:tw-text-md tw-font-medium">{t15}<span className="tw-ml-1 tw-text-iron-50">{t16}</span></span>;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t14 || $[36] !== t17) {
    t18 = <div className="tw-pt-2 tw-flex tw-items-center tw-justify-between">{t14}{t17}</div>;
    $[35] = t14;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t11 || $[39] !== t18) {
    t19 = <div className="tw-pt-2 tw-pb-4 tw-px-2 tw-self-end tw-w-full tw-h-full"><div className="tw-flex tw-flex-col tw-h-full tw-justify-between tw-gap-y-2.5 tw-divide-y tw-divide-solid tw-divide-iron-700 tw-divide-x-0">{t11}{t18}</div></div>;
    $[38] = t11;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t19 || $[42] !== t9) {
    t20 = <div className="tw-group tw-relative tw-flex tw-flex-col tw-bg-gradient-to-br tw-from-iron-900 tw-to-white/5 tw-rounded-lg tw-overflow-hidden tw-px-0.5 tw-pt-0.5 tw-transition tw-duration-300 tw-ease-out tw-ring-1 tw-ring-inset tw-ring-iron-700 hover:tw-ring-iron-600/60 hover:tw-to-white/10">{t9}{t19}</div>;
    $[41] = t19;
    $[42] = t9;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  return t20;
}